// extracted by mini-css-extract-plugin
export default {"textarea":"yqx0p6YBhsCiRiT16qOM","collapsed":"N_odFd_ps0bSYRQVlUs1"};